import { useCallback, useMemo, useState } from "react";
import { CAMPAIGNS } from "../data/campaigns";
import { readDismissed, writeDismissed } from "../lib/dismissal";
import { activeCampaigns } from "../lib/schedule";
import { Campaign } from "../types";

export function useCampaigns(surface: string) {
  const [dismissed, setDismissed] = useState<string[]>(() => readDismissed(surface));

  const campaigns = useMemo<Campaign[]>(
    () => activeCampaigns(CAMPAIGNS).filter((c) => !dismissed.includes(c.id)),
    [dismissed],
  );

  const dismiss = useCallback(
    (ids: string[]) => {
      setDismissed((prev) => {
        const next = Array.from(new Set([...prev, ...ids]));
        writeDismissed(surface, next);
        return next;
      });
    },
    [surface],
  );

  return { campaigns, dismiss };
}
